"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FEEDBACK_FIELD_REMOVE_ITEM_BUTTON = exports.FEEDBACK_FIELD_ITEM = exports.FEEDBACK_FIELD_INPUT = exports.FEEDBACK_FIELD_ADD_ITEM_BUTTON = void 0;
const FEEDBACK_FIELD_INPUT = exports.FEEDBACK_FIELD_INPUT = 'feedback-field-input';
const FEEDBACK_FIELD_ADD_ITEM_BUTTON = exports.FEEDBACK_FIELD_ADD_ITEM_BUTTON = 'feedback-field-add-item-button';
const FEEDBACK_FIELD_ITEM = exports.FEEDBACK_FIELD_ITEM = 'feedback-field-item';
const FEEDBACK_FIELD_REMOVE_ITEM_BUTTON = exports.FEEDBACK_FIELD_REMOVE_ITEM_BUTTON = 'feedback-field-remove-item-button';
